export default "__VITE_ASSET__727a75d5__"